import React, { Component } from 'react'
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import Service from '../../services';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import { Toast } from 'primereact/toast';
import { connect } from 'react-redux';
import { getBranchesLatest } from '../../store/actions';
import withRouter from '../../components/lib/withRouter';
import { exportToExcel } from '../../utils/excelExport';

class BranchWiseMarksReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            exams: [], // Unique exams
            selectedExam: null,
            selectedBranches: [],
            filteredData: [],
            rawData: [],
            dataTableKey: 0, // Add this to control DataTable rerenders
            tableLoading: false // Add separate loading state for table
        };

        this.service = new Service();
    }

    componentDidMount() {
        // this.props.getBranchesLatest(true);
        this.initializeDefaultBranch();
    }

    initializeDefaultBranch() {
        const { branchData } = this.props;
        
        // Wait for branch data to be loaded
        if (branchData && branchData.length > 0) {
            // Select the first branch by default
            const defaultBranch = [branchData[0].key];
            this.setState({
                selectedBranches: defaultBranch
            }, () => {
                // Fetch exams for the default branch
                this.getBranchWiseMarksReportInfo();
            });
        }
    }

    componentDidUpdate(prevProps) {
        // Check if branchData was just loaded
        if ((!prevProps.branchData || prevProps.branchData.length === 0) && 
            this.props.branchData && 
            this.props.branchData.length > 0 && 
            this.state.selectedBranches.length === 0) {
            this.initializeDefaultBranch();
        }
    }

    getBranchWiseMarksReportInfo() {
        if (!this.state.selectedBranches || this.state.selectedBranches.length === 0) {
            return;
        }

        // Set table loading instead of full screen loading
        this.setState({ tableLoading: true });

        // Get selected branch IDs
        const branchIds = this.state.selectedBranches;

        this.service
            .post(`${baseUrlAdmin}/academicsReports/branchWiseMarksReport`, {
                academicYear: localStorage.getItem('userAcademicYear'),
                branchIds: branchIds // Pass selected branch IDs to API
            }, true)
            .then((response) => {
                if (response.status && response?.res?.status) {
                    const rawData = response.res.data;

                    // Filter exams based on selected branches
                    const exams = [...new Map(
                        rawData
                            .filter(item => branchIds.includes(item.branchId))
                            .map(item => [item.examId, { examId: item.examId, examName: item.examName }])
                    ).values()];

                    // Batch state updates together
                    requestAnimationFrame(() => {
                        this.setState(prevState => ({
                            exams,
                            rawData,
                            selectedExam: null,
                            filteredData: [],
                            tableLoading: false,
                            dataTableKey: prevState.dataTableKey + 1
                        }));
                    });
                } else {
                    this.setState({ tableLoading: false });
                }
            })
            .catch((error) => {
                console.error('Error fetching branch-wise marks report:', error);
                this.setState({ tableLoading: false });
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch report data',
                    life: 3000
                });
            });
    }

    onBranchesChange = (selectedBranches) => {
        // Ensure at least one branch is always selected
        if (selectedBranches && selectedBranches.length > 0) {
            this.setState({
                selectedBranches,
                selectedExam: null,
                filteredData: []
            }, () => {
                this.getBranchWiseMarksReportInfo();
            });
        }
    };

    onExamChange = (selectedExam) => {
        this.setState({ selectedExam, filteredData: [] });
    };

    onViewAnalysis = () => {
        const { rawData, selectedExam, selectedBranches } = this.state;
        // Filter data based on selected exam and branches
        const filteredBranchData = rawData.filter(
            item =>
                item.examId === selectedExam.examId &&
                selectedBranches.some(branch => branch === item.branchId)
        );

        // Find the top student across all branches
        const topStudentData = filteredBranchData.reduce((max, current) => {
            return current.topStudent.totalScore > max.topStudent.totalScore ? current : max;
        }, filteredBranchData[0]);

        // Calculate combined data across All Branches
        const combinedData = {
            branchName: 'All Branches',
            type: '',
            topStudent: {
                totalScore: Math.max(...filteredBranchData.map(item => item.topStudent.totalScore)),
                // Include subject scores from the top student
                subjectScores: topStudentData.topStudent.subjectScores
            },
            subjectWiseToppers: filteredBranchData[0].subjectWiseToppers.map(subject => {
                const allScores = filteredBranchData.map(branch => {
                    const subjectTopper = branch.subjectWiseToppers.find(
                        s => s.subjectName === subject.subjectName
                    );
                    return subjectTopper ? subjectTopper.topStudent.score : 0;
                });
                return {
                    subjectName: subject.subjectName,
                    topStudent: {
                        score: Math.max(...allScores)
                    }
                };
            })
        };

        // Transform data to show two rows per branch
        const transformedData = [];

        // Add combined data first (Subject Topper first, then Top Student)
        transformedData.push(
            {
                ...combinedData,
                type: 'Subject Topper'
            },
            {
                ...combinedData,
                type: 'Top Student',
                branchName: '' // Hide branch name for second row
            }
        );

        // Add individual branch data
        filteredBranchData.forEach(branch => {
            // Add row for Subject Topper first
            transformedData.push({
                branchName: branch.branchName,
                type: 'Subject Topper',
                topStudent: branch.topStudent,
                subjectWiseToppers: branch.subjectWiseToppers
            });

            // Add row for Top Student (with empty branch name)
            transformedData.push({
                branchName: '', // Hide branch name for second row
                type: 'Top Student',
                topStudent: branch.topStudent,
                subjectWiseToppers: branch.subjectWiseToppers.map(subject => ({
                    ...subject,
                    score: branch.topStudent.subjectScores.find(
                        s => s.subjectName === subject.subjectName
                    )?.score || 0
                }))
            });
        });

        this.setState({ filteredData: transformedData });
    };

    render() {
        const { exams, selectedExam, selectedBranches, filteredData, isLoading, dataTableKey, tableLoading } = this.state;
        const { branchData } = this.props;

        // Inside the render method, update the columns configuration
        const columns = [
            { field: 'branchName', header: 'Branch' },
            { field: 'type', header: 'Type' },
            { 
                field: 'topStudent.totalScore', 
                header: 'Highest Marks',
                getValue: (rowData) => rowData.type === 'Top Student' ? rowData.topStudent.totalScore : '-'
            },
            ...(filteredData[0]?.subjectWiseToppers?.map(subject => ({
                field: subject.subjectName,
                header: subject.subjectName,
                getValue: (rowData) => {
                    if (rowData.type === 'Top Student') {
                        return rowData.topStudent.subjectScores?.find(
                            s => s.subjectName === subject.subjectName
                        )?.score ?? '-';
                    } else {
                        return rowData.subjectWiseToppers?.find(
                            s => s.subjectName === subject.subjectName
                        )?.topStudent.score ?? '-';
                    }
                }
            })) || [])
        ];

        return (
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                padding: '0',
                marginLeft: "100px",
                marginTop: "55px",
                overflow: 'auto',
            }}>
                <div className="card filters-card mt-1 pt-0">
                    <div className="flex">
                        {/* Branches MultiSelect */}
                        <div className="col-4">
                            <p className="add-vehicle-field-label">
                                Branches <span style={{ color: 'red' }}>*</span>
                            </p>
                            <div className="flex justify-content-start align-items-center">
                                <ClassetMultiSelect
                                    value={selectedBranches}
                                    options={branchData}
                                    onChange={(e) => this.onBranchesChange(e.value)}
                                    optionLabel="name"
                                    optionValue="key"
                                    placeholder="Select Branches"
                                    width={"25vw"}
                                    height={"48px"}
                                    style={{ border: '10px solid #E6E8EA' }}
                                />
                            </div>
                        </div>

                        {/* Exam Dropdown */}
                        <div className="col-4">
                            <p className="add-vehicle-field-label">
                                Exam <span style={{ color: 'red' }}>*</span>
                            </p>
                            <div className="flex justify-content-start align-items-center">
                                <ClassetDropdown
                                    value={selectedExam}
                                    options={exams}
                                    onChange={(e) => this.onExamChange(e.value)}
                                    optionLabel="examName"
                                    placeholder="Select Exam"
                                    width={"25vw"}
                                    height={"48px"}
                                    style={{ border: '10px solid #E6E8EA' }}
                                    disabled={selectedBranches.length === 0}
                                />
                            </div>
                        </div>

                        {/* View Analysis Button */}
                        <div className="flex gap-2 order-1 ml-auto mt-5">
                            <Button
                                label="Download Report"
                                onClick={() => {
                                    // Use the same columns configuration as DataTable
                                    const exportColumns = [
                                        { field: 'branchName', header: 'Branch' },
                                        { field: 'type', header: 'Type' },
                                        { 
                                            field: 'topStudent.totalScore', 
                                            header: 'Highest Marks',
                                            getValue: (rowData) => rowData.type === 'Top Student' ? rowData.topStudent.totalScore : '-'
                                        },
                                        ...(filteredData[0]?.subjectWiseToppers?.map(subject => ({
                                            field: subject.subjectName,
                                            header: subject.subjectName,
                                            getValue: (rowData) => {
                                                if (rowData.type === 'Top Student') {
                                                    return rowData.topStudent.subjectScores?.find(
                                                        s => s.subjectName === subject.subjectName
                                                    )?.score ?? '-';
                                                } else {
                                                    return rowData.subjectWiseToppers?.find(
                                                        s => s.subjectName === subject.subjectName
                                                    )?.topStudent.score ?? '-';
                                                }
                                            }
                                        })) || [])
                                    ];
                                    
                                    exportToExcel(filteredData, 'Branch_Wise_Marks_Report', exportColumns);
                                }}
                                disabled={!filteredData.length}
                                className="p-button-secondary"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#fff",
                                    color: "#076EFF",
                                    marginRight: "10px"
                                }}
                            />
                            <Button
                                label="View Analysis"
                                onClick={this.onViewAnalysis}
                                disabled={!selectedExam || selectedBranches.length === 0}
                                className="p-button-primary"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#076EFF",
                                    color: "#fff"
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className='datatable-report-demo mx-2' style={{ position: 'relative' }}>
                    {isLoading && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 1000
                        }}>
                            <LoadingComponent />
                        </div>
                    )}
                    
                    {filteredData.length > 0 && (
                        <DataTable
                            key={dataTableKey}
                            value={filteredData}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                            responsiveLayout="scroll"
                            columnResizeMode="expand"
                            resizableColumns
                            className="p-datatable-custom"
                            loading={tableLoading}
                            loadingIcon="pi pi-spinner"
                            showLoader={false}
                        >
                            <Column
                                header="S.No"
                                body={(rowData, { rowIndex }) => {
                                    // Don't show serial number for empty branch name rows (second row of each pair)
                                    if (!rowData.branchName) return null;

                                    // Calculate actual serial number (rowIndex / 2 since we have pairs of rows)
                                    const serialNumber = Math.floor(rowIndex / 2) + 1;

                                    return (
                                        <div style={{
                                            fontWeight: rowData.branchName === 'All Branches' ? 'bold' : 'normal'
                                        }}>
                                            {serialNumber}
                                        </div>
                                    );
                                }}
                                style={{ width: '70px' }}
                            />
                            <Column
                                field="branchName"
                                header="Branch"
                                body={(rowData) => {
                                    if (!rowData.branchName) return null; // Don't show anything if branchName is empty
                                    return (
                                        <div style={{
                                            fontWeight: rowData.branchName === 'All Branches' ? 'bold' : 'normal',
                                            color: rowData.branchName === 'All Branches' ? '#076EFF' : 'inherit'
                                        }}>
                                            {rowData.branchName}
                                        </div>
                                    );
                                }}
                            />
                            <Column
                                field="type"
                                header="Type"
                                body={(rowData) => (
                                    <div style={{
                                        fontWeight: rowData.branchName === 'All Branches' ? 'bold' : 'normal'
                                    }}>
                                        {rowData.type}
                                    </div>
                                )}
                            />
                            <Column
                                field="topStudent.totalScore"
                                header="Highest Marks"
                                body={(rowData) => (
                                    <div style={{
                                        fontWeight: rowData.branchName === 'All Branches' ? 'bold' : 'normal'
                                    }}>
                                        {rowData.type === 'Top Student' ? rowData.topStudent.totalScore : '-'}
                                    </div>
                                )}
                            />
                            {filteredData[0]?.subjectWiseToppers.map((subject, index) => (
                                <Column
                                    key={index}
                                    header={subject.subjectName}
                                    body={(rowData) => {
                                        let score;
                                        if (rowData.type === 'Top Student') {
                                            // For Top Student, get score from subjectScores
                                            score = rowData.topStudent.subjectScores?.find(
                                                s => s.subjectName === subject.subjectName
                                            )?.score;
                                        } else {
                                            // For Subject Topper, get score from subjectWiseToppers
                                            score = rowData.subjectWiseToppers?.find(
                                                s => s.subjectName === subject.subjectName
                                            )?.topStudent.score;
                                        }
                                        return (
                                            <div style={{
                                                fontWeight: rowData.branchName === 'All Branches' ? 'bold' : 'normal'
                                            }}>
                                                {score ?? '-'}
                                            </div>
                                        );
                                    }}
                                />
                            ))}
                        </DataTable>
                    )}
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    branchData: (state.branchDataLatest?.data?.data.filter(each => each.level == 1)) || []
});

export default connect(mapStateToProps, {
    getBranchesLatest
})(withRouter(BranchWiseMarksReport));

